import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "calc(100vh - 64px)",
    },
    title: {
        textAlign: "center",
    },
    start_button_container: {
        paddingBottom: 40,
    },
    start_button: {
        fontWeight: 600,
    },
}))